export const FORM_DOMAIN_PRODUCT = 'PRODUCT';

export type FormDomain = typeof FORM_DOMAIN_PRODUCT;

export const FORM_DOMAINS: { value: FormDomain; label: string }[] = [
  { value: FORM_DOMAIN_PRODUCT, label: '제품' },
];

export const INSPECTION_FORM_TYPE_ACCEPTANCE = 'ACCEPTANCE';
export const INSPECTION_FORM_TYPE_MID = 'MID';
export const INSPECTION_FORM_TYPE_FINAL = 'FINAL';

export type InspectionFormType =
  | typeof INSPECTION_FORM_TYPE_ACCEPTANCE
  | typeof INSPECTION_FORM_TYPE_MID
  | typeof INSPECTION_FORM_TYPE_FINAL;

export const INSPECTION_FORM_TYPES: { value: InspectionFormType; label: string }[] = [
  { value: INSPECTION_FORM_TYPE_ACCEPTANCE, label: '인수검사' },
  { value: INSPECTION_FORM_TYPE_MID, label: '중간검사' },
  { value: INSPECTION_FORM_TYPE_FINAL, label: '제품검사' },
];

export interface InspectionFormItem {
  itemId?: number;
  sortOrder?: number | null;
  itemName: string;
  descriptionText?: string | null;
  standardText?: string | null;
  methodText?: string | null;
  remark?: string | null;
}

export interface InspectionFormAttachment {
  attachmentId: number;
  fileName: string;
  contentType?: string | null;
  fileSize?: number | null;
  createdAt?: string | null;
}

export interface InspectionForm {
  formId: number;
  domain?: FormDomain | string | null;
  formType: InspectionFormType | string;
  title: string;
  memo?: string | null;
  tags?: string[] | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  linkId?: number | null;
  itemCount?: number | null;
  attachmentCount?: number | null;
  items?: InspectionFormItem[] | null;
  attachments?: InspectionFormAttachment[] | null;
}

export interface InspectionFormPayload {
  domain?: FormDomain | string;
  formType: InspectionFormType | string;
  title: string;
  memo?: string;
  tags?: string[];
  items?: InspectionFormItem[];
}

export function formDomainLabel(domain?: string | null) {
  return FORM_DOMAINS.find((item) => item.value === domain)?.label ?? domain ?? '-';
}

export function formTypeLabel(formType?: string | null) {
  return INSPECTION_FORM_TYPES.find((item) => item.value === formType)?.label ?? formType ?? '-';
}

export function formMatchesProductTags(formTags?: string[] | null, productTags?: string[] | null) {
  const form = (formTags ?? []).map((t) => t.toLowerCase());
  if (form.length === 0) return true;
  const product = new Set((productTags ?? []).map((t) => t.toLowerCase()));
  return form.some((tag) => product.has(tag));
}
